<template>
  <div class="Modal__mask" v-show="show" transition="Modal" @click="show = false">
    <div class="Modal__wrapper">
      <div class="Modal__container" @click.stop >
        <span :style="'height: 150px; width: 150px; background-color: ' + color" >{{ color }}</span>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        required: true,
        twoWay: true
      }
    },
    events: {
      closeModal () {
        this.show = false
      }
    },
    ready () {
      document.addEventListener('keydown', (e) => {
        if (this.show && e.keyCode === 27) {
          this.show = false
        }
      })
    }
  }
</script>

<style lang='scss' >
  @import "src/assets/sass/variables/main";
  .Modal__mask {
    position         : fixed;
    z-index          : 9998;
    top              : 0;
    left             : 0;
    width            : 100%;
    height           : 100%;
    display          : table;
    transition       : opacity .3s ease;
    background-color : rgba(0, 0, 0, .5);
  }
  .Modal__wrapper {
    display          : table-cell;
    vertical-align   : middle;
  }
  .Modal__container {
    width            : 600px;
    margin           : 0px auto;
    padding          : 20px;
    background-color : #fff;
    border-radius    : 2px;
    box-shadow       : 0 2px 8px rgba(0, 0, 0, .33);
    transition       : all .3s ease;
    p{
      margin-bottom: 10px;
    }
  }
  .Modal__header h3{
    margin-top    : 0;
    color         : $green;
    text-transform: uppercase;
  }
  .Modal__body {
    margin : 20px 0;
  }
  .Modal__footer{
    display: flex;
    justify-content: flex-end;
    button{
      margin-left: 10px;
    }
  }
  .Modal__default-button {
    float : right;
  }

  // Vue transtions
  .Modal-enter, .Modal-leave {
    opacity : 0;
  }
  .Modal-enter .Modal__container,
  .Modal-leave .Modal__container {
    -webkit-transform : scale(1.1);
    transform         : scale(1.1);
  }
  [class*="Modal__buton-"]{
    color         : white;
    border        : none;
    padding       : 10px 20px;
    background    : $green;
    text-transform: uppercase;
  }
  .Modal__buton-danger{
    background: $red;
  }
  .Modal__buton-back{

  }
</style>



// WEBPACK FOOTER //
// Modal.vue?020ad1c0